/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { notDependencies } from './dependenciesNot.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { zerosDependencies } from './dependenciesZeros.generated';
import { createAnd } from '../../factoriesAny.js';
export var andDependencies = {
  equalScalarDependencies: equalScalarDependencies,
  matrixDependencies: matrixDependencies,
  notDependencies: notDependencies,
  typedDependencies: typedDependencies,
  zerosDependencies: zerosDependencies,
  createAnd: createAnd
};